import React, { useState } from 'react';
import { motion } from 'framer-motion';
import variants from 'motion-variants';
import SearchInput from 'components/SearchInput';
import MenuItem from 'components/MenuItem';
import { useHistory } from 'react-router-dom';

const PageMenu: React.FC<{ items: any[]; base: string }> = ({
  items,
  base,
  children,
}) => {
  const history = useHistory();
  const [filter, setFilter] = useState('');

  const tailwindClasses = {
    nav: [
      'md:w-64 h-48 md:h-full shadow-sm text-gray-700 bg-gray-200 overflow-hidden flex flex-col flex-shrink-0 border-r border-gray-400 gray-scrollbar',
    ],
    header: ['h-18 border-b overflow-hidden flex-shrink-0 p-3'],
    ul: ['overflow-y-auto pt-2 flex flex-col h-full'],
  };

  return (
    <nav
      // exit="out"
      // animate="in"
      // initial="out"
      // variants={variants.slideFromLeft}
      // transition={variants.slideTransition}
      className={tailwindClasses.nav.join(' ')}
    >
      <header className={tailwindClasses.header.join(' ')}>
        <SearchInput
          placeholder="Filter"
          value={filter}
          onResetClick={() => setFilter('')}
          onChange={(event) => {
            setFilter(event.target.value);
          }}
        />
      </header>
      <ul className={tailwindClasses.ul.join(' ')}>
        {items
          ?.filter((item) =>
            item.label.toLowerCase().includes(filter.toLowerCase()),
          )
          .map((item, i) => (
            <MenuItem
              tight
              key={i}
              to={item?.to}
              Icon={item?.icon}
              label={item?.label}
              caption={item?.caption}
              textClass={item?.textClass || 'text-gray-600'}
              activeTextClass={item?.activeTextClass || 'text-jcap-700'}
              activeIndicatorClass={item?.activeIndicatorClass || 'bg-jcap-200'}
              pageMenuItem={true}
            />
          ))}
        <div className="flex-grow" onClick={() => history.push(base)} />
      </ul>
      {children}
    </nav>
  );
};

export default PageMenu;
